<script lang="ts">
  import PhoneWhite from "../../../icons/PhoneWhite.svg"
  import type { RecommendationProduct } from "../../../interfaces/RecommendationProduct"
  import { recommendation } from "../../../stores/recommendation"

  import ProductAddToCartButton from "./ProductAddToCartButton.svelte"
  import ProductQuantity from "./ProductQuantity.svelte"

  export let product: RecommendationProduct

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  $: ctaPhoneNumber =
    $recommendation.details?.brand.ctaPhoneNumber

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  $: storeCartUrl = $recommendation.details?.brand.storeCartUrl 
</script>

<div
  class="product-actions{product.quantityDisabled ? '-single' : ''}"
  class:multiline={!storeCartUrl}
>
  {#if storeCartUrl}
    {#if !product.quantityDisabled}
      <ProductQuantity {product} />
    {/if}
    <ProductAddToCartButton {product} />
  {:else}
    {#if product.url}
      <a class="product-url-button" href={product.url}>
        Shop directly from {product.name}
      </a>
    {/if}
    {#if ctaPhoneNumber}
      <a class="product-phone-button" href="tel:{ctaPhoneNumber}">
        <svelte:component
          this={PhoneWhite}
          class="button-icon"
        />
        {ctaPhoneNumber}
      </a>
    {/if}
  {/if}
</div>
